<template>
    <div class="tree-box model" :style="curNopadding">
      <!-- <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>-->
      <hoverTitle v-if="treeTitle" :treeTitle="treeTitle"></hoverTitle>
      <el-input
        v-show="treeNodeFilter"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
      >
      </el-input>
      <!-- {{treeList}} -->
      <!-- 
        用于树节点多选
        lazy
        :load="loadNode" -->
      <el-tree
        v-if="treeList.length"
        :data="treeList"
        :node-key="curTreeKey"
        :props="defaultProps"
        :show-checkbox="showCheckbox"
        :current-node-key="curCheckedKey"
        highlight-current
        default-expand-all
        :expand-on-click-node="false"
        class="deteleDialog"
        :style="{ height: treeHeight }"
        :filter-node-method="filterNode"
        :check-strictly="checkStrictly"
        :check-on-click-node="true"
        @node-expand="treeExpand"
        @node-click="clickNodeFn"
        @check-change="handleCheckChange"
        ref="tree"
      >
        <!-- :filter-node-method="filterNode" -->
        <!-- @node-click="getTreeId" -->
        <div
          class="custom-tree-node"
          :class="data == checkNode ? 'checkBgc' : ''"
          slot-scope="{ node, data }"
          :id="node.id"
          @mouseover="ifEditMenu ? mouseoverTree(data) : ''"
          @mouseleave="ifEditMenu ? mouseleaveTree(data) : ''"
        >
          <!-- 根据某个字段判断该节点(如parentId=0)是否是父节点，父节点前面的icon使用folder.png，子节点前面的icon使用file.png -->
          <img 
            v-if="showIcon && data.children && data.children.length > 0"
            class="icon folder"
            alt=""
          />
          <img
            v-else-if="showIcon && treeIcon && treeIcon != ''"
            class="icon"
            style="width: 0.13rem"
            :src="treeIcon"
            alt=""
          />
          <img
            v-else-if="showIcon"
            class="icon file"
            style="width: 0.13rem"
            alt=""
          />
          <!-- +'('+data[countName]+')' -->
          <span
            class="each-node"
            :style="{ width: nodeWidth }"
            :title="data[labelname]"
          >
            <span class="each-tree-title">{{ data[labelname] }}</span>
            <span class="each-tree-title" v-if="data[countName] != null"
              >({{ data[countName] }})</span
            >
            <!-- v-html="ruleTitle(data[countName])" -->
          </span>
          <!-- v-if="item.ifEdit" -->
          <el-dropdown
            v-show="data.ifEdit"
            placement="bottom"
            @command="
              (command) => {
                handleDropdown(command, data);
              }
            "
          >
            <span class="el-dropdown-link">
              <i style="transform: rotate(90deg)" class="el-icon-more" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="addCurrent">新增</el-dropdown-item>
              <el-dropdown-item
                v-if="data[labelname] != '全部'"
                command="editMenu"
                >编辑</el-dropdown-item
              >
              <el-dropdown-item v-if="data[labelname] != '全部'" command="delete"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-tree>
    </div>
  </template>
  
  <script>
  import hoverTitle from "@/components/EXHoverTitle";
  export default {
    name: 'ETree',
    components: {
      hoverTitle,
    },
    props: {
      treeHeight: {
        type: String,
        default: 'calc(100% - .5rem)'
      },
      // tree上方的文字
      treeTitle: {
        type: String,
        default: "",
      },
      // tree上关键字过滤
      treeNodeFilter: {
        type: Boolean,
        default: false,
      },
      // 树组件
      treeList: {
        type: Array,
      },
      // tree数据对应的label
      labelname: {
        type: String,
        default: "label",
      },
      treeExpandedId: {
        type: Number,
      },
      // 节点id
      treeKey: {
        type: String,
        default: "label",
      },
      // 获取右侧表格数据方法
      fetchTableData: {
        type: Function,
      },
      // 是否编辑节点
      ifEditMenu: {
        type: Boolean,
        default: false,
      },
      // 树是否多选
      showCheckbox: {
        type: Boolean,
        default: false,
      },
      countName: {
        type: String,
        default: 'number'
      },
      nodeWidth: {
        type: String,
        default: '70%'
      },
      nopadding: Boolean,
      checkedKey: {
        type: String,
        default: '全部'
      },
       // 是否展示图标
       showIcon: {
        type: Boolean,
        default: true,
      },
      // 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法
      checkStrictly: {
        type: Boolean,
        default: false,
      },
      defaultKeys:{
        type: Array,
        default: () => ([])
      },
      treeIcon:String,   //自定义叶子节点图标图片
    },
    data() {
      return {
        filterText: "",
        activeData: null, // 当前操作数据
        treeExpandedKeys: [], // 记录打开节点的数组
        orgId: "", // 记录打开节点的id
        orgName: "", // 记录打开节点的name
        // treeKey: '', // 控制tree渲染的key
        nodeQuery: {
          orgShortName: "", // 编辑树节点表单的model
        },
        defaultProps: {
          children: "children",
          label: this.labelname,
        },
        innerVisible: false, // 是否显示操作节点弹框
        checkNode: "",
        // treeExpandedId: '',
        colorId: "",
        leftNum: ""
      };
    },
    computed: {
      curNopadding() {
        if (this.nopadding) {
          return 'padding-left:0;padding-right:0'
        }
      },
      curCheckedKey: {
        get() {
          return this.checkedKey
        },
        set(val) {
          return val
        }
      },
      curTreeKey:{
        get() {
          return this.treeKey
        },
        set(val) {
          return val
        }
      }
    },
    created() {
      this.defaultProps.label = this.labelname;
      this.treeExpandedId = this.treeExpandedId;
      console.log("treeList", this.treeList, this.defaultProps);
      this.$forceUpdate();
    },
    mounted() {
      // const selectDom = this.$refs.tree[0].$el.querySelector('.is-current')
      // console.log('selectDom', selectDom)
      // setTimeout(() => {
      //   this.$refs.select[0].scrollToOption({ $el: selectDom })
      // }, 0)
      // this.$refs.tree.setCurrentKey(this.curCheckedKey)
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
      treeExpandedId: function (val) {
        if (val === "") {
          this.checkNode = "";
        }
      },
      treeList(newVal) {
        if (newVal) {
            this.$nextTick(() => { //在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
              if(this.curCheckedKey && this.curCheckedKey.length > 0){
                this.$refs.tree.setCurrentKey(this.curCheckedKey) //初始化设置点选
              }
              if(this.defaultKeys && this.defaultKeys.length > 0){
                this.$refs.tree.setCheckedKeys(this.defaultKeys) //初始化设置多选
              }
            })
        }
      }
    },
    methods: {
      // 节点选中状态发生变化时的回调
      handleCheckChange(nodeObj, isChecked) {
        this.$emit("checkTreeData", {nodeObj,isChecked});
      },
      ruleTitle(items) {
        const title = items
        const rep = new RegExp(this.filterText, 'g')
        const resDtring = `<span style='color:#145afe;'>${this.filterText}</span>`
        return title.replace(rep, resDtring)
      },
      mouseoverTree(data) {
        this.$set(data, 'ifEdit', true)
      },
      mouseleaveTree(data) {
        this.$set(data, 'ifEdit', false)
      },
      // 懒加载节点
      // loadNode(){
      //   if (node.level === 0) {
      //     return resolve([{ label: '全部' }]);
      //   }
      //   if (node.level > 3) return resolve([]);
      // },
      handleDropdown(command, row) {
        console.log(command, row);
        this.$emit("fetchTableData", command, row);
      },
      filterNode(value, treeList) {
        if (!value) return true;
        return treeList[this.labelname].indexOf(value) !== -1;
      },
      // 当节展开时，记录下打开节点的id
      treeExpand(data, node, self) {
        // this.treeExpandedKeys.push(data.orgId)
      },
      // 节点点击时
      clickNodeFn(data) {
        this.curCheckedKey = data[this.labelname]
        // this.$refs.tree.setCurrentKey(this.checkedKey)
        this.$emit("fetchTableData", data, "filterData");
      },
      // 加载树
      loadTreeNode(node, resolve) {
        const id = node ? node.data.orgId : "";
        this.getTreeData({ id }).then((re) => {
          const result = re.data;
          const treeData = result.data;
          if (result.success && node.level === 0) {
            // 如果是第一次加载数据，直接返回数据
            resolve(treeData);
          } else if (result.success) {
            // 如果非第一次加载数据，将返回数据拼接到操作节点的childList属性中
            node.data.childList = treeData;
            resolve(treeData);
          } else {
            resolve([]);
            this.$message({
              type: "error",
              message: "加载数据出错！",
            });
          }
        });
      },
      getTreeId(data, node) {
        if (this.checkNode === data) {
          this.checkNode = "";
          document.getElementById(this.colorId).parentNode.style = "";
          document.getElementById(this.colorId).parentNode.style.paddingLeft =
            this.leftNum;
          this.colorId = "";
        } else {
          this.checkNode = data;
          if (this.colorId) {
            if (document.getElementById(this.colorId)) {
              document.getElementById(this.colorId).parentNode.style = "";
              document.getElementById(this.colorId).parentNode.style.paddingLeft =
                this.leftNum;
            }
          }
          this.leftNum = document.getElementById(
            node.id
          ).parentNode.style.paddingLeft;
          document.getElementById(node.id).parentNode.style.background =
            "#F5F7FA";
          this.colorId = node.id;
        }
        this.$emit("getTreeId", { treeData: this.checkNode });
      },
      // 刷新key值，重新渲染tree
      // renderTree() {
      //   this.treeKey = +new Date();
      // },
      /* renderContent(h, { node, data, store }) {
            return (<span class='custom-tree-node'></span>)
          },*/
      // 新增节点
      /* append(data) {
            this.editType = 'ADD'
            this.innerVisible = true
            // 记录当前节点数据，供新增弹框关闭后回调用
            this.activeData = data
            <span class='custom__tree__icons'>
              <el-tooltip class='item' style='margin:0 0.06rem' effect='dark' content='新增' placement='top'>
                <i class='tree-icon el-icon-plus' onclick='append(data)'></i>
              </el-tooltip>
              <el-tooltip class='item' style='margin:0 0.06rem' effect='dark' content='编辑' placement='top'>
                <i class='tree-icon el-icon-edit' onclick='edit(node, data)'></i>
              </el-tooltip>
              <el-tooltip class='item' style='margin:0 0.06rem' effect='dark' content='删除' placement='top'>
                <i class='tree-icon el-icon-close' onclick='remove(node, data)'></i>
              </el-tooltip>
            </span>
          },*/
      // 新增节点回调函数
      /* appendCallback() {
            const data = this.activeData
            const nodeQuery = this.nodeQuery
            nodeQuery.parentId = data.id === '0' ? '' : data.id
            // 将新节点名称和父节点id传递到后台
            addNode(nodeQuery).then(re => {
              this.renderTree()
            })
          },
          // 编辑节点回调函数
          editCallback() {
            const data = this.activeData
            const nodeQuery = this.nodeQuery
            data.orgShortName = nodeQuery.orgShortName
            // 将节点新名称和节点id传递到后台
            editNode(data).then(re => {
              const result = re.data
              if (result && result.success) {
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
                this.renderTree()
              }
            })
          },
          // 移除节点
          remove(node, data) {
            removeNode(data.id).then(re => {
              const result = re.data
              if (result && result.success) {
                // 重新渲染tree
                this.renderTree()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              }
            })
          },
          // 编辑节点
          edit(node, data) {
            this.nodeQuery.orgShortName = data.orgShortName
            // 记录当前操作数据
            this.activeData = data
            this.editType = 'EDIT'
            this.innerVisible = true
          },
          rest() {
            this.activeData = null
            this.nodeQuery = {
              orgShortName: '',
              parentId: ''
            }
            this.editType = 'ADD'
            this.innerVisible = false
          },
          sure() {
            const editType = this.editType
            this.$refs['parentNodeQuery'].validate(valid => {
              if (valid) {
                editType === 'ADD' ? this.appendCallback() : this.editCallback()
                this.reset()
              } else {
                console.log('error submit!!')
                return false
              }
            })
          }*/
    },
  };
  </script>
  
  <style scoped lang="scss">
  @import '../../styles/variables.scss';
  .tree-box {
    width: 100%;
    height: 100%;
    padding-top: 0.05rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    box-sizing: border-box;
    /deep/ .el-tree-node:focus > .el-tree-node__content {
      @include tree_node_bg($tree-node-bgD);
    }
    /deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
      @include tree_bg($tree-bgD);
    }
    /deep/ .el-tree-node__content {
      height: 0.4rem;
      line-height: 0.4rem;
      position: relative;
      .each-tree-title {
        // font-size: 0.16rem;
        // font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .el-dropdown {
        position: absolute;
        right: 0.1rem;
        color: #2153c0;
        z-index: 99;
      }
      &:hover{
         @include tree_bg($tree-bgD);
      }
    }
    /deep/ .el-tree {
      height: calc(100% - 0.5rem);
      overflow: auto;
    }
  }
  .custom-tree-node {
    width: 100%;
    display: flex;
    align-items: center;
    .icon {
      display: inline-block;
      width: 0.19rem;
      margin: 0 0.12rem 0 0;
      line-height: 0.3rem;
      background-size: cover;
    }
    .folder{
      @include tree_folder_img('folder.png');
    }
    .file{
      @include tree_file_img('file.png');
    }
    .each-node {
      // max-width: 1.1rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  // /deep/ .el-tree-node__expand-icon {
  //   color: #c0c4cc;
  // }
  </style>


// WEBPACK FOOTER //
// src/components/EXTree/tree.vue